import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ApiConstants } from '../../shared/constants/api-constants';
import { Observable } from 'rxjs';
import { HardCopyActivityTransitionDetails } from '../models/hardcopyactivity-transition-details';

@Injectable({
  providedIn: 'root'
})
export class HardcopyactivityAuditService {

  constructor(private httpClient:HttpClient) { }

  
  getHardCopyActivityTransitionDetails = (hardCopyActivityId: string):
    Observable<HardCopyActivityTransitionDetails> => {
    return this.httpClient.get<HardCopyActivityTransitionDetails>(
      ApiConstants.HardCopyActivty_Transition_Details_Api +
      '/' +
      `${hardCopyActivityId}`,
    );
  }
}
